import { gsap } from 'gsap';
import Vue from 'vue';

Vue.component('promo-article-wrapper', {
    props: {
        financingTypeDropdownValues: {
            value: Array,
        },
    },

    data() {
        return {
            financePlan: null,
            selectedModel: null, // Add this line
            allFinancePlans: JSON.parse(this.financingTypeDropdownValues),
            selectedAccordionModel: null,
            selectedTooltipPromo: null,
            isAnimating: false,
        };
    },

    mounted() {
        this.getFinancePlanFromQueryParameters();
        this.togglePriceSubtitleContainerVisibility(this.financePlan, true);
        this.toggleOpenAccordion(this.financePlan, 'financePlan');
        // Set initial model if finance plan exists
        if (this.financePlan) {
            this.selectedModel = this.financePlan;
        }
        EventBus.$on('promo-financing-type-set', (financingTypeValue) => {
            this.financePlan = financingTypeValue;
        });
    },

    methods: {
        getFinancePlanFromQueryParameters() {
            const urlParams = new URLSearchParams(window.location.search);
            const financePlan = urlParams.get('finance_plan');
            if (!financePlan) return;
            this.financePlan = financePlan;

            const selectedPlan = this.allFinancePlans.find(
                (plan) => plan.value === financePlan,
            );

            if (!selectedPlan) return;
            EventBus.$emit('promo-article-finance-plan-set', selectedPlan);
        },

        changeSelectedPlan(planProp) {
            if (this.isAnimating) return;

            const selectedPlan = this.allFinancePlans.find(
                (plan) => plan.value === planProp,
            );

            if (!selectedPlan) return;
            EventBus.$emit('promo-article-finance-plan-set', selectedPlan);

            const shouldPriceSubtitleHide =
                planProp !== this.financePlan ||
                !Boolean(
                    this.$refs[`${planProp}-button`].querySelector(
                        '.promo-article-compare-plan-card__subtitle-container--hidden',
                    ),
                );

            this.togglePriceSubtitleContainerVisibility(
                planProp,
                shouldPriceSubtitleHide,
            );
            this.toggleOpenAccordion(planProp, 'financePlan');
            this.financePlan = planProp;

            // Update URL parameter without adding to history
            const url = new URL(window.location);
            url.searchParams.set('finance_plan', planProp);
            window.history.replaceState({}, '', url);
        },

        checkIsPlanCardSelected(plan) {
            return this.financePlan === plan
                ? 'promo-article-compare-plan-card--active'
                : '';
        },

        slugifyModelName(modelName, index) {
            if (/[a-zA-Z]/.test(modelName)) {
                return modelName
                    .replace(/\s+/g, '-') // Replace spaces with hyphens
                    .toLowerCase();
            }

            return `model-${modelName.replace(/[€,]/g, '')}-${index}`;
        },

        changeSelectedModel(model, index) {
            const slugifiedModelName = this.slugifyModelName(model, index);
            this.toggleOpenAccordion(
                slugifiedModelName,
                'selectedAccordionModel',
            );
            this.selectedAccordionModel = slugifiedModelName;
        },

        toggleOpenAccordion(containerClass, propToCheck) {
            this.isAnimating = true;

            // Reset all chevrons first
            const allChevrons = document.querySelectorAll(
                '.promo-article-compare-plan-card__button__chevron, .promo-campaign-prices-accordion__button__chevron',
            );
            allChevrons.forEach((chevron) => {
                gsap.to(chevron, {
                    duration: 0,
                    rotate: 0,
                });
            });

            if (!containerClass || !propToCheck) {
                this.isAnimating = false;
                return;
            }

            const container = document.querySelector(`.${containerClass}`);
            const chevron = document.querySelector(
                `.promo-article-compare-plan-card__button__chevron--${containerClass}`,
            );
            const buttonChevron = document.querySelector(
                `.promo-campaign-prices-accordion__button__chevron--${containerClass}`,
            );

            if (this[propToCheck]) {
                const oldSelectedPlan = document.querySelector(
                    `.${this[propToCheck]}`,
                );
                if (oldSelectedPlan) {
                    if (
                        this[propToCheck] !== containerClass &&
                        oldSelectedPlan.style.height !== '0px'
                    ) {
                        this.togglePriceSubtitleContainerVisibility(
                            this[propToCheck],
                            false,
                        );
                    }

                    const timeline = gsap.timeline();
                    timeline.to(oldSelectedPlan, {
                        duration: 0.7,
                        height: 0,
                        ease: 'power4.out',
                    });
                }
            }

            if (container.clientHeight > 0) {
                this.selectedTooltipPromo = null;
            }

            const timeline = gsap.timeline();
            timeline
                .to(
                    container,
                    {
                        duration: 0.7,
                        height: container.clientHeight > 0 ? 0 : 'auto',
                        ease: 'power4.out',
                        onComplete: () => {
                            this.isAnimating = false;
                        },
                    },
                    'start',
                )
                .to(
                    [chevron, buttonChevron].filter(Boolean),
                    {
                        duration: 0,
                        rotate: container.clientHeight > 0 ? 0 : -180,
                    },
                    'start',
                );
        },

        togglePriceTooltip(selectedTooltipPromo) {
            if (this.selectedTooltipPromo === selectedTooltipPromo) {
                this.selectedTooltipPromo = null;
                return;
            }
            this.selectedTooltipPromo = selectedTooltipPromo;

            this.$nextTick(() => {
                if (window.innerWidth < 768) return;

                const activeTooltips = this.$el.querySelectorAll(
                    '.model-header__toolbar-text--active',
                );
                activeTooltips.forEach((tooltip) => {
                    if (
                        !tooltip.classList.contains(
                            'model-header__toolbar-price',
                        )
                    )
                        return;

                    const tooltipButton = tooltip.closest(
                        '.model-header__toolbar-wrapper',
                    );
                    if (!tooltipButton) return;

                    const rect = tooltipButton.getBoundingClientRect();
                    const tooltipWidth = tooltip.offsetWidth;
                    const viewportWidth = window.innerWidth;

                    const spaceOnLeft = rect.left;
                    const spaceOnRight = viewportWidth - rect.right;

                    tooltip.classList.remove(
                        'model-header__toolbar-price--align-left',
                    );
                    tooltip.classList.remove(
                        'model-header__toolbar-price--align-right',
                    );

                    if (
                        spaceOnLeft > tooltipWidth &&
                        spaceOnRight < tooltipWidth
                    ) {
                        tooltip.classList.add(
                            'model-header__toolbar-price--align-left',
                        );
                    } else {
                        tooltip.classList.add(
                            'model-header__toolbar-price--align-right',
                        );
                    }
                });
            });
        },

        togglePriceTooltipActiveClass(tooltipPromo) {
            return this.selectedTooltipPromo === tooltipPromo
                ? 'model-header__toolbar-text--active'
                : '';
        },

        togglePriceSubtitleContainerVisibility(plan, shouldHide) {
            const container = this.$refs[`${plan}-content`];

            if (!container) return;

            if (shouldHide) {
                container.classList.add(
                    'promo-article-compare-plan-card__subtitle-container--hidden',
                );
            } else {
                container.classList.remove(
                    'promo-article-compare-plan-card__subtitle-container--hidden',
                );
            }
        },

        // Keyboard handling for plan card interaction
        handlePlanCardKeydown(event, planSlug) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.changeSelectedPlan(planSlug);
            }
        },

        // Keyboard handling for tooltip button
        handleTooltipKeydown(event, planTitle) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                event.stopPropagation(); // Prevent triggering the plan card
                this.togglePriceTooltip(planTitle);
            }
        },

        // Check if tooltip is expanded for ARIA
        checkTooltipExpanded(planTitle) {
            return this.selectedTooltipPromo === planTitle ? 'true' : 'false';
        },

        // This is here because CraftCMS creates ternary operator that checks if cached file exists.
        // This happens when you add a link to a file on a CDN that's on the same environment as the website.
        // This logic probably shouldn't even exist here because twig should handle this on it's own.
        // But since we're creating a logic where everything is parsed and showed through Vue, which I think is a bad idea in general,
        // I think that this should be parsed on the backend and then passed to Vue.
        // For now this is the best solution I could come up with.
        parseDisclaimerForInternalLinks(disclaimer) {
            if (!disclaimer?.length) return;

            const assetRegex = /\{asset:\d+:url\|\|([^}]+)\}/g;
            const entryRegex = /\{entry:(\d+)(@\d+)?:url\|\|([^}]+)\}/g;
            const isLinkInDisclaimer = disclaimer.includes('<a');

            if (!isLinkInDisclaimer) return disclaimer;

            return disclaimer
                .split('<a')
                .map((item) => item.replace(assetRegex, '$1'))
                .map((item) => item.replace(entryRegex, '$3'))
                .join('<a');
        },
    },
});
